const data = document.querySelector('.js-cells-data')

if (data) {
  const priceFull = Number(data.getAttribute('data-price-1'))
  const priceSale = Number(data.getAttribute('data-price-2'))
  const dataTime = Number(data.getAttribute('data-time'))
  const resultSpan = document.querySelector('.calculate-result')
  const inputHour = document.querySelector('.js-calculate')
  const inputBack = document.querySelector('.calculate-result__input')

  inputHour.addEventListener('input', function(event) {
    const value = event.target.value

    const createElem = function(value = '', priceTag = false) {
      if (priceTag) {
        inputBack.value = `${value}, ${priceTag}`
        resultSpan.classList.remove('calculate-result_error')
        resultSpan.innerHTML = `К&nbsp;оплате без учета НДС ${value}&nbsp;р., стоимость часа&nbsp;&mdash; ${priceTag}&nbsp;р.`
      } else {
        resultSpan.classList.add('calculate-result_error')
        resultSpan.innerHTML = 'Минимально 2 ч'
      }
    }

    if (value > 1 && value <= dataTime) {
      createElem(value * priceFull, priceFull)
    } else if (value > dataTime) {
      createElem(value * priceSale, priceSale)
    } else {
      createElem()
    }
  })
}


